var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.871,
    height: 25.689,
    viewBox: "0 0 26.871 25.689",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.794,
    y1: 0.839,
    x2: 0.123,
    y2: 0.378,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-star",
    "data-name": "Icon feather-star",
    d: "M14.936,1.5a1.373,1.373,0,0,1,1.231.765l3.408,6.9L27.2,10.284a1.373,1.373,0,0,1,.76,2.343L22.442,18l1.3,7.587a1.373,1.373,0,0,1-1.993,1.448l-6.815-3.584L8.12,27.031a1.373,1.373,0,0,1-1.993-1.448L7.429,18l-5.514-5.37a1.373,1.373,0,0,1,.76-2.343L10.3,9.17l3.408-6.9A1.373,1.373,0,0,1,14.936,1.5Zm9.112,11.1-5.583-.816a1.373,1.373,0,0,1-1.033-.751l-2.5-5.056-2.5,5.056a1.373,1.373,0,0,1-1.033.751L5.824,12.6l4.039,3.934a1.373,1.373,0,0,1,.4,1.216L9.3,23.3,14.3,20.68a1.373,1.373,0,0,1,1.278,0L20.566,23.3l-.953-5.556a1.373,1.373,0,0,1,.4-1.216Z",
    transform: "translate(-1.5 -1.5)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0d1dcacad7ddbc05bb837ddf4a8b146c.svg";
export { ForwardRef as ReactComponent };